import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {REVIEW_ROUTES} from '../../constants'
import {MdOutlineSummarize} from 'react-icons/md'
import {useCurrentUserAnPCheck} from '@therms/react-modules'

function ReviewMobileMenuLink() {
  if (!useCurrentUserAnPCheck(({anp}) => anp.role.ops.access.viewOpsSummary)) {
    return null
  }

  return (
    <MobileMenuLink to={REVIEW_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={MdOutlineSummarize} size="sm" />
        <span>Review</span>
      </div>
    </MobileMenuLink>
  )
}

export {ReviewMobileMenuLink}
